export const CENTER_EDUTALK = 1;
export const CENTER_DOI_TAC = 0;

export const ECOACH = 295;
export const IELTS = 516;
export const TOEIC = 518;
export const CAMBRIDGE = 530;
export const QUANTUMLEAP = 529;
export const MENTER_ENGLISH_MASTERY = 532;

export const WARRANTY_SERVICE_CENTERS = [ECOACH, IELTS, MENTER_ENGLISH_MASTERY];

export function isWarrantyServiceCenter(centerId) {
    return WARRANTY_SERVICE_CENTERS.includes(Number(centerId));
}
